module.exports = __webpack_public_path__ + "img/w3_circle_filter_light.767099b1.png";